import React from 'react'
import { motion } from 'framer-motion'
import { spring } from '@/lib/animations'

function ProfileBadge({ className = "", onClick }) {
  const isClickable = !!onClick
  
  return (
    <motion.div 
      layout
      className={`group flex items-center gap-3 transition-[gap] duration-200 ease text-sm text-muted-foreground font-mono rounded-b-lg px-3 py-2 ${isClickable ? 'hover:gap-4 cursor-pointer' : ''} ${className}`}
      onClick={onClick}
      whileHover={isClickable ? { scale: 1.1 } : undefined}
      transition={spring.snappy}
    >
      <motion.img 
        layout
        src="/profile/optimized/me-crt-192.webp"
        alt="Matt Dunn" 
        className="w-8 h-8 rounded-full object-cover" style={{ willChange: 'transform' }}
      />
      <motion.div layout className="flex flex-col justify-center">
        <div className="font-md text-foreground" style={{ willChange: 'transform' }}>Matt Dunn</div>
        <div className={`text-xs mt-0 ${isClickable ? 'group-hover:mt-1' : ''} transition-[margin] duration-200 ease`}>Software Design & Technology</div>
      </motion.div>
    </motion.div>
  )
}

export default ProfileBadge
